/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { MasterImportResponse } from '../model/masterImportResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CustomerTypeCodeControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingDELETE1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingDELETE1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingDELETE1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingDELETE1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingGET1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingGET1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingGET1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingGET1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingHEAD1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingHEAD1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingHEAD1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingHEAD1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingOPTIONS1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingOPTIONS1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingOPTIONS1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPATCH1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPATCH1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPATCH1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPATCH1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPOST1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPOST1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPOST1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPOST1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importAll
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importAllUsingPUT1(observe?: 'body', reportProgress?: boolean): Observable<Array<MasterImportResponse>>;
    public importAllUsingPUT1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MasterImportResponse>>>;
    public importAllUsingPUT1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MasterImportResponse>>>;
    public importAllUsingPUT1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Array<MasterImportResponse>>(`${this.basePath}/import/Customer/typecode/all`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantStatTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantStatTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantStatTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstApplicantTypeTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstApplicantTypeTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstApplicantTypeTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstApplicantTypeTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstApplicantType`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGenderTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGenderTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGenderTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGenderTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGender`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstGstStatusTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstGstStatusTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstGstStatusTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstGstStatusTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstGstStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstMaritalStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstMaritalStatTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstMaritalStatTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstMaritalStatTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstMaritalStatus`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstPrimaryRelTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstPrimaryRelTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstPrimaryRelTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstPrimaryRelTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstPrimaryRel`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingDELETE(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingDELETE(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingDELETE(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingDELETE(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingGET(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingGET(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingHEAD(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingHEAD(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingHEAD(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingHEAD(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.head<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingOPTIONS(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingOPTIONS(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingOPTIONS(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingOPTIONS(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.options<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingPATCH(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingPATCH(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPATCH(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPATCH(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingPOST(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingPOST(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPOST(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPOST(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * importCstResidentStatTypcode
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importCstResidentStatTypcodeUsingPUT(observe?: 'body', reportProgress?: boolean): Observable<MasterImportResponse>;
    public importCstResidentStatTypcodeUsingPUT(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPUT(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MasterImportResponse>>;
    public importCstResidentStatTypcodeUsingPUT(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<MasterImportResponse>(`${this.basePath}/import/Customer/typecode/cstResidentStat`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
